/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import "@/assets/stylus/stubParamsConfig.styl";
import moment from "moment";
// import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Row, Col, message, Card, Table, Modal, Input, Upload, Tooltip } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { TableLocale } from "@/utils/publicParam";
import fetchHandler from "@/fetch/fetchHandler";
import {
  prefixFile,
  stubCfgInfo,
  stubCfgSync,
  cfgFromStub,
  stubCfgSave,
  stubCmd,
  checkJQfile,
  getUnDirectStubConfigInfoList,
  getUnDirectNewConfigInfo,
  saveUnDirectConfigInfo,
} from "@/fetch/fetchApi";
// import ConfigModify from './configModify';
// 国际化切换语言
import Tool from "@/utils/Tool";
import "./index.styl";
import ModifyLog from "./modifyLog";
import StubParamPriceModal from "./stubParamPriceModal";
import StubParamChargingModal from "./stubParamChargingModal";

let isEdit = false;
let saveVisible = "none";

const timeTypeMap = new Map([
  [1, "峰"],
  [2, "尖"],
  [3, "谷"],
  [4, "平"],
]);
@connect((state) => state)
class StubParamsConfig extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubParamsConfig;
    this.state = {
      cfgData: {}, //列表数据
      data: [],
      stubId: this.props.stubId,
      stubGroupName: this.props.stubGroupName,
      devType: this.props.devType,
      configModifyVisible: false,
      resultData: new Map(),
      editList: [],
      tableColumnsModel: null,
      changeData: {},
      changeValueFlag: false, // 修改配置模式
      getNewConfigFlag: false,
      secondGetNewConfig: 0,
      checkBtnLoading: false,
      priceSetVisible: false,
      chargingSetVisible: false,
      fileName: "",
      fileLists: [],
    };
    this.init();
  }

  componentWillMount() {
    this.setState({
      tableColumnsModel: this.props.isUnDirect ? this.tableUnDirectConfig() : this.tableConfig(),
    });
  }

  tableUnDirectConfig = () => {
    const tableUnDirectColumns = [
      {
        title: "配置字段",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "字段格式",
        dataIndex: "des",
        key: "des",
        render: (text, record) => {
          return <div style={{ padding: "10px", whiteSpace: "break-spaces" }}>{text}</div>;
        },
      },
      {
        title: "配置内容",
        dataIndex: "stubValue",
        key: "stubValue",
        render: (text, record) => {
          if (
            record.key === "chargeDuration" ||
            record.key === "chargePower" ||
            record.key === "function" ||
            record.key === "timeStart"
          ) {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                onClick={(e) => {
                  e.target.blur();
                  this.setState({
                    priceSetVisible: true,
                  });
                }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
              />
            );
          }
        },
      },
    ];
    return tableUnDirectColumns;
  };

  tableConfig = () => {
    const uploadProps = {
      // 显支持上传png、jpg、pdf、word、Excel格式的文件，支持多选上传，文件大小不能超过100M
      accept: ".txt",
      action: `${prefixFile}/uploadFile.do`,
      data: () => {
        const fileName = `${moment(new Date()).format("x")}${Math.floor(
          Math.random() * 10,
        )}${Math.floor(Math.random() * 10)}${Math.floor(Math.random() * 10)}.txt`;
        this.setState({
          currentJQName: fileName,
        });
        return {
          storeName: "ds_upload",
          filePath: fileName,
        };
      },
      onChange: (e) => {
        if (e.fileList.length === 2) {
          e.fileList = e.fileList.slice(-1);
        }
        if (e.file.status === "done") {
          const record = this.state.cfgData.configData.filter((item) => item.key === "fileCrc")[0];
          this.handleStubCfgEditChange2(this.state.currentJQName.split(".")[0], record);
          this.setState({
            fileName: e.file.name,
          });
        }
        this.setState({
          fileLists: [...e.fileList],
        });
      },
      onRemove: () => {
        const record = this.state.cfgData.configData.filter((item) => item.key === "fileCrc")[0];
        this.setState({
          fileName: "",
          currentJQName: "",
        });
        this.handleStubCfgEditChange2("", record);
        this.delChangeResult();
        // const resultData = this.state.resultData.filter(item => item.name !== "本地鉴权的编码文件");
      },
    };
    const tableColumnsModel = [
      {
        title: this.internationalization.title1, // '配置字段(字段范围)',
        dataIndex: "name",
        key: "name",
      },
      {
        title: "字段格式范围", // '字段格式范围',
        dataIndex: "des",
        key: "des",
        render: (text, record) => {
          if (record.key === "offlineBillingModel" || record.key === "reserveCharingStation") {
            const names = record.des.split(",");
            const first = names.shift();
            return (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    padding: "10px",
                    borderBottom: "1px solid #f0f0f0",
                    textAlign: "center",
                  }}>
                  {first}
                </div>
                <div className="config-sp-box">
                  {names.map((v) => (
                    <div>{v}</div>
                  ))}
                </div>
              </div>
            );
          }
          return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div style={{ padding: "10px", whiteSpace: "break-spaces" }}>{text}</div>
              <div
                style={{
                  marginRight: 4,
                  display: this.props.isUnDirect&&record.key === 'timeStart' ? "block" : "none",
                }}>
                <Tooltip
                  title={() => (
                    <span style={{ color: "#000" }}>
                      HH表示小时、范围00~24，MM表示分钟、范围00或10倍数
                    </span>
                  )}
                  color="#ffffff"
                  overlayClassName="white-tooltip">
                  <QuestionCircleFilled
                    style={{
                      color: "#D9D9D9",
                      marginRight: 4,
                      top: 1,
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          );
        },
      },
      {
        title: this.internationalization.title6, // '设备端配置',
        dataIndex: "stubValue",
        render: (text, record) => {
          if (record.key === "offlineBillingModel" || record.key === "reserveCharingStation") {
            return null;
          }
          // 计费规则
          if (
            record.key === "num" ||
            record.key === "time" ||
            record.key === "elePrice" ||
            record.key === "serverPrice" ||
            record.key === "type"
          ) {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                onClick={(e) => {
                  e.target.blur();
                  this.setState({
                    priceSetVisible: true,
                  });
                }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
              />
            );
          }
          // 预约充电配置
          if (
            record.key === "appointNum" ||
            record.key === "appointStartTime" ||
            record.key === "appointEndTime" ||
            record.key === "appointEle" ||
            record.key === "appointTimeLen"
          ) {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                onClick={(e) => {
                  e.target.blur();
                  this.setState({
                    chargingSetVisible: true,
                  });
                }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
              />
            );
          }
          if (record.key === "fileCrc") {
            if (this.state.changeValueFlag) {
              return (
                <div>
                  {text ? (
                    <a
                      href="javascript:void(0);"
                      style={{ display: "block", paddingLeft: 15 }}
                      onClick={() => this.handleDownload(text)}>
                      {text}.txt {this.internationalization.btn3}
                    </a>
                  ) : (
                    ""
                  )}
                  <Button
                    onClick={this.handleDownloadModal}
                    type="text"
                    style={{ color: "#5584FF" }}>
                    模板下载
                  </Button>
                  <Upload fileList={this.state.fileLists} maxCount={1} {...uploadProps}>
                    <Button type="text" style={{ color: "#5584FF" }}>
                      TXT上传
                    </Button>
                  </Upload>
                </div>
              );
            } else {
              return text ? (
                <a href="javascript:void(0);" onClick={() => this.handleDownload(text)}>
                  {text}
                  {this.internationalization.btn3}
                </a>
              ) : (
                ""
              );
            }
          } else {
            return (
              <Input
                disabled={!this.state.changeValueFlag}
                defaultValue={text}
                style={{ "max-width": "250px" }}
                value={
                  this.state.changeData[record.key] || this.state.changeData[record.key] === ""
                    ? this.state.changeData[record.key]
                    : text
                }
                onChange={(e) => this.handleStubCfgEditChange(e, record)}
              />
            );
          }
        },
      },
    ];
    return tableColumnsModel;
  };

  init() {
    // 调用接口获取数据
    this.fetch();
  }

  fetch() {
    // 表格加载效果
    this.setState({
      tableLoading: true,
    });
    let fetchUrl = this.props.isUnDirect ? getUnDirectStubConfigInfoList : stubCfgInfo;
    let fetchParam = this.props.isUnDirect
      ? { stubId: this.state.stubId }
      : { stubId: this.state.stubId, devType: this.state.devType };
    fetchHandler(fetchUrl, {
      ...fetchParam,
    }).then((res) => {
      console.log('fetch:',res.data);
      if (res && res.code === "success") {
        let newData = [];
        for (const [key, value] of Object.entries(res.data)) {
          // console.log(`${key}: ${value}`);
          if (key !== "stubId" && key !== 'reportLatestTime' && key !== 'updateLatestTime') {
            newData.push({
              key,
              type: key,
              name:
                key === "chargeDuration"
                  ? "充电时长"
                  : key === "chargePower"
                  ? "充电电量"
                  : key === "function"
                  ? "接地检测开关"
                  : "定时启动时间",
              des:
                key === "chargeDuration"
                  ? "充电时长(0-65535分钟)"
                  : key === "chargePower"
                  ? "充电电量(0-255)"
                  : key === "function"
                  ? "接地检测开关(0开1关)"
                  : "定时启动时间(HHMM)",
              stubValue: value,
            });
          }
        }
        console.log("newData:", newData);
        this.setState(
          {
            cfgData: this.props.isUnDirect
              ? {
                  configData: newData,
                  stubConfigAppearTime:res.data.reportLatestTime,
                  stubConfigModifyTime:res.data.updateLatestTime
                }
              : res.data,

          },
          () => {
            this.setState({
              tableColumnsModel: this.tableConfig(),
            });
          },
        );
      }
    });
  }

  handleDownload = (value) => {
    // let  url = "https://app-ccchong-com.oss-cn-qingdao.aliyuncs.com/" + value + ".txt";

    const excelUrl = `${prefixFile}/exportStubCfgFile.do`;
    const params = `fileName=${value}`;

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
    // window.open(url);
    // window.URL.revokeObjectURL(url);
  };

  // 下载模板
  handleDownloadModal = (value) => {
    // let  url = "https://app-ccchong-com.oss-cn-qingdao.aliyuncs.com/" + value + ".txt";

    const excelUrl = `${prefixFile}/template/download.do`;
    const params = "fileName=鉴权编码文件模板.txt&serviceName=fileCrc";

    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
    // window.open(url);
    // window.URL.revokeObjectURL(url);
  };

  // 记录每次修改的记录
  handleStubCfgEditChange = (e, record) => {
    let paramData = "";
    if (this.state.cfgData && this.state.cfgData.configData) {
      this.state.cfgData.configData.forEach((ele) => {
        if (ele.key === record.key) {
          paramData = ele.stubValue;
        }
      });
    }
    const changeData = this.state.changeData;
    if (paramData === e.target.value) {
      console.log("---------内容一样----------");
      delete changeData[record.key];
    } else {
      changeData[record.key] = e.target.value;
    }
    console.log({ changeData });
    this.setState({
      changeData: changeData,
    });
  };

  // 记录特殊字段修改的记录
  handleStubCfgEditChange2 = (changedValue, record) => {
    const changeData = this.state.changeData;
    changeData[record.key] = changedValue;
    this.setState({
      changeData: changeData,
    });
  };

  handleModifyBtnClick = () => {
    isEdit = true;
    saveVisible = "block";
    this.addTable();
    this.setState({
      configModifyVisible: true,
    });
  };

  componentDidMount() {
    message.warn(this.internationalization.msg1, 5);
  }

  handleSyncBtnClick = () => {
    stubCfgSync({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg2);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  };

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  // 使用设备端配置
  handleCfgFromStubBtnClick = () => {
    cfgFromStub({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg2);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  };

  handleModifyLogBtnClick = () => {
    this.setState({
      configModifyLogVisible: true,
      isNeedFlush: true,
    });
  };

  formatterResultData = () => {
    const { cfgData, changeData } = this.state;
    const results = [];
    Object.keys(changeData).forEach((key) => {
      const item = cfgData.configData.find((v) => v.key === key);
      // 展示表格字段
      results.push({
        value: changeData[key],
        name: item.name,
      });
    });
    return results;
  };

  // 对提交字段编辑
  formatterResultParams = () => {
    const { cfgData, changeData } = this.state;
    const results = {};
    Object.keys(changeData).forEach((key) => {
      const item = cfgData.configData.find((v) => v.key === key);
      if (results[item.type] || results[item.type] === 0) {
        const itemInfo = {};
        itemInfo[key] = changeData[key];
        results[item.type].push(itemInfo);
      } else {
        results[item.type] = [];
        const itemInfo = {};
        itemInfo[key] = changeData[key];
        results[item.type].push(itemInfo);
      }
    });
    console.log({ results });
    return results;
  };

  // 删除本地鉴权文件修改
  delChangeResult = () => {
    const { resultData } = this.state;
    // delete resultData["200"];
    resultData.delete("200");
    this.setState({
      resultData,
    });
  };

  //修改保存
  handleSaveBtnClick = () => {
    // console.log(this.state);
    if (this.state.changeData && JSON.stringify(this.state.changeData) !== "{}") {
      const results = this.formatterResultData();
      const resultData = this.formatterResultParams();
      console.log({ resultData });
      Modal.confirm({
        icon: null,
        width: 800,
        content: (
          <div>
            <h4 style={{ textAlign: "center", marginBottom: "24px" }}>
              确认修改以下<span style={{ color: "red" }}>{results.length}</span>
              项参数吗？
            </h4>
            {results.map((v) => (
              <Row>
                <Col span={10} style={{ color: "red", textAlign: "right" }}>
                  {v.name}
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  修改为
                </Col>
                <Col span={10} style={{ color: "red" }}>
                  {v.name === "本地鉴权的编码文件" ? this.state.fileName : v.value}
                </Col>
              </Row>
            ))}
          </div>
        ),
        onOk: () => {
          console.log({ resultData }, { results });
          if (this.props.isUnDirect) {
            //校验配置参数
            if (
              results.find((x) => x.name == "定时启动时间") &&
              results.find((x) => x.name == "定时启动时间").value &&
              results.find((x) => x.name == "定时启动时间").value.toString().length !== 4
            ) {
              message.error("定时启动时间格式不正确");
              return;
            }
            if (
              results.find((x) => x.name == "充电电量") &&
              results.find((x) => x.name == "充电电量").value &&
              !(
                results.find((x) => x.name == "充电电量").value.toString().length < 4 &&
                0 < Number(results.find((x) => x.name == "充电电量").value) &&
                Number(results.find((x) => x.name == "充电电量").value) <= 255
              )
            ) {
              message.error("充电电量格式不正确");
              return;
            }
            if (
              results.find((x) => x.name == "充电时长") &&
              results.find((x) => x.name == "充电时长").value &&
              !(
                results.find((x) => x.name == "充电时长").value.toString().length < 6 &&
                0 < Number(results.find((x) => x.name == "充电时长").value) &&
                Number(results.find((x) => x.name == "充电时长").value) <= 65535
              )
            ) {
              message.error("充电时长格式不正确");
              return;
            }
            if (
              results.find((x) => x.name == "接地检测开关") &&
              results.find((x) => x.name == "接地检测开关").value &&
              !["0", "1"].includes(results.find((x) => x.name == "接地检测开关").value.toString())
            ) {
              message.error("接地检测开关格式不正确");
              return;
            }

            saveUnDirectConfigInfo({
              stubId: this.props.stubId,
              chargeDuration:
                results.find((x) => x.name == "充电时长") &&
                results.find((x) => x.name == "充电时长").value,
              chargePower:
                results.find((x) => x.name == "充电电量") &&
                results.find((x) => x.name == "充电电量").value,
              function:
                results.find((x) => x.name == "接地检测开关") &&
                results.find((x) => x.name == "接地检测开关").value,
              timeStart:
                results.find((x) => x.name == "定时启动时间") &&
                results.find((x) => x.name == "定时启动时间").value,
            }).then((res) => {
              if (res && res.data.code === "200") {
                message.success("配置修改成功！");
                this.setState({
                  changeValueFlag: false,
                },()=>{
                  this.init();
                })
                
              } else {
                message.error(`${res.data.text}`);
              }
            });
          } else {
            // 首先校验鉴权文件
            if (results.filter((item) => item.name === "本地鉴权的编码文件").length > 0) {
              const fileInfo = results.filter((item) => item.name === "本地鉴权的编码文件");
              checkJQfile({
                storeName: "ds_upload",
                filePath: `${fileInfo[0].value}.txt`,
              }).then((res) => {
                if (res && res.data.code === "200") {
                  stubCfgSave({
                    platformParams: JSON.stringify(resultData),
                    stubId: this.state.stubId,
                  }).then((res2) => {
                    if (res2 && res2.data.code === "200") {
                      this.setState(
                        {
                          resultData: new Map(),
                          changeData: {},
                          configModifyVisible: false,
                          changeValueFlag: false,
                        },
                        () => {
                          this.init();
                          message.success("修改配置命令已下发，可一分钟后刷新查看最新配置");
                        },
                      );
                    } else {
                      message.error(res2.data.text);
                    }
                  });
                } else {
                  message.error(res.data.text);
                }
              });
            } else {
              stubCfgSave({
                platformParams: JSON.stringify(resultData),
                stubId: this.state.stubId,
              }).then((res) => {
                if (res && res.data.code === "200") {
                  this.setState(
                    {
                      resultData: new Map(),
                      changeData: {},
                      configModifyVisible: false,
                      changeValueFlag: false,
                    },
                    () => {
                      this.init();
                      message.success("修改配置命令已下发，可一分钟后刷新查看最新配置");
                    },
                  );
                } else {
                  message.error(res.data.text);
                }
              });
            }
          }
        },
      });
      // alert(JSON.stringify(this.strMapToObj(this.state.resultData)));
      // arr.push([this.state.resultData]);
    } else {
      message.info(this.internationalization.msg3);
    }
  };

  // 命令下发
  handleConfigCheckClick = () => {
    this.setState({
      checkBtnLoading: true,
    });
    stubCmd({ stubId: this.state.stubId }).then((res) => {
      this.setState({
        checkBtnLoading: false,
      });
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg4);
        this.init();
        this.getNewConfigFlag();
      } else {
        message.error(res.data.text);
      }
    });
  };

  strMapToObj(strMap) {
    const obj = Object.create(null);
    for (const [k, v] of strMap) {
      const arr = [];
      for (const val of v) {
        const obj2 = Object.create(null);
        for (const [i, j] of val) {
          obj2[i] = j;
          arr.push(obj2);
        }
      }
      obj[k] = arr;
    }
    return obj;
  }

  // 刷新
  handlerefreshBtnClick = () => {
    this.init();
    this.setState({
      tableLoading: false,
    });
  };

  // 获取最新配置60秒限制
  getNewConfigFlag = () => {
    this.setState({
      getNewConfigFlag: true,
      secondGetNewConfig: 60,
    });
    const timeOut = setInterval(() => {
      if (this.state.secondGetNewConfig > 0) {
        const s = this.state.secondGetNewConfig - 1;
        this.setState({
          secondGetNewConfig: s,
        });
      } else {
        this.setState({
          getNewConfigFlag: false,
          secondGetNewConfig: 0,
        });
        clearInterval(timeOut);
      }
    }, 1000);
  };

  //非直连设备--配置信息--获取最新配置
  handleUnDirectNewConfig = () => {
    getUnDirectNewConfigInfo({
      stubId: this.props.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success("获取最新配置成功！");
      } else {
        message.error(res.data.text);
      }
    });
  };

  render() {
    const textAlign = {
      textAlign: "center",
    };

    const rowCustomStyle = {
      marginTop: "20px",
    };

    const content = (
      <div className="stubParamsConfig">
        <Row>
          {!this.props.isUnDirect ? (
            <Col span={6} offset={1}>
              <label htmlFor="stubParamsConfig">{this.internationalization.title8}：</label>
              <span>{this.state.stubId}</span>
            </Col>
          ) : null}
          {!this.props.isUnDirect ? (
            <Col span={15} offset={2}>
              <label htmlFor="stubParamsConfig">{this.internationalization.title9}：</label>
              <span>{this.state.stubGroupName}</span>
            </Col>
          ) : null}
        </Row>
        <Row style={rowCustomStyle} gutter={24}>
          <Col span={8}>
            <Card style={textAlign}>
              <div>
                <label htmlFor="span">配置最新上报时间：</label>
                <span>
                  {(this.state.cfgData && this.state.cfgData.stubConfigAppearTime) || "--"}
                </span>
              </div>
            </Card>
          </Col>
          {!this.props.isUnDirect ? (
            <Col span={8}>
              <Card style={textAlign}>
                <div>
                  <label htmlFor="span">配置最新下发修改时间:</label>
                  <span>
                    {(this.state.cfgData && this.state.cfgData.platformConfigIssueTime) || "--"}
                  </span>
                </div>
              </Card>
            </Col>
          ) : null}
          <Col span={8}>
            <Card style={textAlign}>
              <div>
                <label htmlFor="12">配置最新变更时间:</label>
                <span>
                  {(this.state.cfgData && this.state.cfgData.stubConfigModifyTime) || "--"}
                </span>
              </div>
            </Card>
          </Col>
        </Row>
        <Row
          style={{
            ...rowCustomStyle,
            justifyContent: "flex-end",
          }}>
          {!this.props.isUnDirect ? (
            <Col span={4} offset={1}>
              <label htmlFor="stubParamsConfig">
                {this.internationalization.title16}:(SCPP2.1
                {this.state.devType === 0 ? "交流" : "直流"})
              </label>
            </Col>
          ) : null}
          <Col span={18} offset={1} style={{ textAlign: "right" }}>
            {this.state.changeValueFlag ? (
              <span>
                <Button
                  type="primary"
                  style={{ marginLeft: "4px" }}
                  onClick={this.handleSaveBtnClick}>
                  保存
                </Button>
                <Button
                  type="primary"
                  style={{ marginLeft: "4px" }}
                  onClick={() => {
                    this.setState(
                      {
                        resultData: new Map(),
                        changeData: {},
                        changeValueFlag: false,
                      },
                      () => {
                        this.setState({
                          tableColumnsModel: this.tableConfig(),
                        });
                      },
                    );
                  }}>
                  取消
                </Button>
              </span>
            ) : (
              <Button
                type="primary"
                style={{ marginLeft: "4px" }}
                onClick={() => {
                  this.setState(
                    {
                      changeValueFlag: true,
                    },
                    () => {
                      this.setState({
                        tableColumnsModel: this.tableConfig(),
                      });
                    },
                  );
                }}>
                修改配置
              </Button>
            )}
            <Button
              type="primary"
              disabled={this.state.changeValueFlag || this.state.getNewConfigFlag}
              style={{ marginLeft: "4px" }}
              loading={this.state.checkBtnLoading}
              onClick={
                this.props.isUnDirect ? this.handleUnDirectNewConfig : this.handleConfigCheckClick
              }>
              获取最新配置
              {this.state.secondGetNewConfig > 0 ? `(${this.state.secondGetNewConfig}s)` : ""}
            </Button>
            {/* 变更记录 */}
            {!this.props.isUnDirect ? (
              <Button
                type="primary"
                disabled={this.state.changeValueFlag}
                style={{ marginLeft: "4px" }}
                onClick={this.handleModifyLogBtnClick}>
                {this.internationalization.title21}
              </Button>
            ) : null}
            {/* 配置刷新 */}
            <Button
              type="primary"
              disabled={this.state.changeValueFlag}
              style={{ marginLeft: "4px" }}
              onClick={this.handlerefreshBtnClick}>
              {this.internationalization.title22}
            </Button>
          </Col>
        </Row>
        <Row style={rowCustomStyle}>
          <Col span={22} offset={1}>
            <div className="configTable">
              <Table
                columns={this.state.tableColumnsModel}
                dataSource={(this.state.cfgData && this.state.cfgData.configData) || ""}
                pagination={false}
                bordered
                locale={TableLocale}
                className="sc-table"
                scroll={{ y: 440 }}
              />
            </div>
          </Col>
        </Row>

        <Modal
          title={this.internationalization.title21}
          width="1100px"
          footer={null}
          visible={this.state.configModifyLogVisible}
          onCancel={() => {
            this.modalVisibleAction("configModifyLogVisible", false);
          }}>
          <ModifyLog stubId={this.state.stubId} />
          {/* handle={this.handleModifyLog} */}
        </Modal>

        <StubParamPriceModal
          okFunction={(returnValue) => {
            // 获取record
            const record1 = this.state.cfgData.configData.filter((item) => item.key === "num")[0];
            const record2 = this.state.cfgData.configData.filter((item) => item.key === "time")[0];
            const record3 = this.state.cfgData.configData.filter(
              (item) => item.key === "elePrice",
            )[0];
            const record4 = this.state.cfgData.configData.filter(
              (item) => item.key === "serverPrice",
            )[0];
            // const record5 = this.state.cfgData.configData.filter(item => item.key === "type")[0];
            this.handleStubCfgEditChange2(returnValue.num, record1);
            this.handleStubCfgEditChange2(returnValue.time, record2);
            this.handleStubCfgEditChange2(returnValue.elePrice, record3);
            this.handleStubCfgEditChange2(returnValue.serverPrice, record4);
            //  this.handleStubCfgEditChange2(returnValue.type,record5);
            this.setState({
              priceSetVisible: false,
            });
          }}
          onCancel={() => {
            this.setState({
              priceSetVisible: false,
            });
          }}
          visible={this.state.priceSetVisible}
        />
        <StubParamChargingModal
          okFunction={(returnValue) => {
            // 获取record
            const record1 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointNum",
            )[0];
            const record2 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointStartTime",
            )[0];
            const record3 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointEndTime",
            )[0];
            const record4 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointEle",
            )[0];
            const record5 = this.state.cfgData.configData.filter(
              (item) => item.key === "appointTimeLen",
            )[0];
            this.handleStubCfgEditChange2(returnValue.appointNum, record1);
            this.handleStubCfgEditChange2(returnValue.appointStartTime, record2);
            this.handleStubCfgEditChange2(returnValue.appointEndTime, record3);
            this.handleStubCfgEditChange2(returnValue.appointEle, record4);
            this.handleStubCfgEditChange2(returnValue.appointTimeLen, record5);
            this.setState({
              chargingSetVisible: false,
            });
          }}
          onCancel={() => {
            this.setState({
              chargingSetVisible: false,
            });
          }}
          visible={this.state.chargingSetVisible}
        />
      </div>
    );
    return content;
  }
}

export default injectIntl(StubParamsConfig);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubParamsConfig.js